import isEmpty from 'just-is-empty';

interface UserData {
  email: string;
  phoneNo: string;
  accountType: string;
  name: string;
}

export const MessageBody = (type: any, browserData: any, receipts: any, translationData: any, userData: Partial<UserData>, location?: string) => {
  const lastReceipt = receipts?.[0]?.receiptNo ?? 'N/A';
  const registeredID = userData.accountType === 'email' ? userData.email : userData.phoneNo;
  const browserName = isEmpty(browserData) ? 'N/A' : browserData.browser.name;
  const browserMajor = isEmpty(browserData) ? 'N/A' : browserData.browser.major;
  const phoneModel = isEmpty(browserData) ? 'N/A' : browserData.device.model;
  const osName = isEmpty(browserData) ? 'N/A' : browserData.os.name;
  const osVersion = isEmpty(browserData) ? 'N/A' : browserData.os.version;

  const word =
    translationData.typeMessage +
    '\n\n\n\n\n\n' +
    '------------------------------------------\n' +
    translationData.helpTroubleshoot +
    '\n' +
    translationData.phoneModel +
    phoneModel +
    '\n' +
    translationData.phoneOS +
    osName +
    ' ' +
    osVersion +
    '\n' +
    translationData.browserVersion +
    browserName +
    ' ' +
    browserMajor +
    '\n' +
    translationData.registeredId +
    registeredID +
    '\n' +
    translationData.latestReceipt +
    lastReceipt +
    '\n------------------------------------------';

  const whatsAppword =
    '------------------------------------------\n\n' +
    translationData.helpTroubleshoot +
    '\n\n' +
    translationData.phoneModel +
    phoneModel +
    '\n' +
    translationData.phoneOS +
    osName +
    ' ' +
    osVersion +
    '\n' +
    translationData.browserVersion +
    browserName +
    ' ' +
    browserMajor +
    '\n' +
    translationData.registeredId +
    registeredID +
    '\n' +
    translationData.latestReceipt +
    lastReceipt +
    '\n' +
    '\n------------------------------------------\n\n' +
    translationData.typeMessage;

  const baseCountryChangeWord =
    'I want to request a change in where my data is located. Here are the details about my current account:' +
    '\n\n' +
    translationData.name +
    ': ' +
    userData.name +
    '\n' +
    translationData.registeredId +
    registeredID +
    '\n' +
    'Current Data Location: ' +
    location +
    '\n' +
    'Preferred Data Location: ' +
    '[Pick one from the following: Indonesia, Japan]' +
    '\n' +
    'Reason: ' +
    '\n\n\n' +
    'Please assess this request and inform me about the process at [My Email Address].' +
    '\n\n' +
    'Thank you,' +
    '\n' +
    userData.name;

  switch (type) {
    case 'email':
      return word;
    case 'whatsapp':
      return whatsAppword;
    case 'baseCountryChange':
      return baseCountryChangeWord;
    default:
      return word;
  }
};
